import { contactInfo } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
          意见反馈
        </h2>
        <p className="text-sm text-foreground-500 mb-10">
          {contactInfo.intro}
        </p>
        <div className="rounded-lg border border-background-300/40 bg-background-50/70 p-6 md:p-8">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-full bg-primary-500/10 flex items-center justify-center">
              <i className="ri-mail-line text-primary-400 text-lg"></i>
            </div>
            <span className="text-base md:text-lg font-medium text-foreground-700">
              {contactInfo.email}
            </span>
          </div>
          <p className="text-xs text-foreground-400 mb-6">{contactInfo.responseTime}</p>
          <div className="flex flex-wrap justify-center gap-3">
            {contactInfo.tips.map((tip, idx) => (
              <span
                key={idx}
                className="px-4 py-2 text-xs font-medium text-foreground-500 bg-background-100 rounded-full border border-background-300/30"
              >
                {tip}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}